import { combineReducers } from 'redux';
import type { UnknownAction } from 'redux';
import type { ThunkDispatch } from 'redux-thunk';

import create from '/shared/state/store';

import { reducers as defaultReducers } from '/shared/state/reducers';
import { reducers as customReducers } from '/business/shared/state/reducers';

const reducedReducers = combineReducers({ ...defaultReducers, ...customReducers });

export type RootState = ReturnType<typeof reducedReducers>;
export type AppDispatch = ThunkDispatch<RootState, undefined, UnknownAction>;

export const { store, persistor } = create(reducedReducers);
